import React from 'react';
import HeaderTitle from 'header/components/title';

const LoginHeaderTitle = () => (<HeaderTitle title="Login" />);

export default LoginHeaderTitle;



// WEBPACK FOOTER //
// ./login/components/header.jsx